// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a195e3a9","453":"c9521dfd","455":"e1d86fc6"}[chunkId] + ".chunk.js";
};